(function () {
  'use strict';


  angular.module('web2print.shared')
    .directive('selectedProduct', selectedProduct);

  function selectedProduct () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/shared/selected-product/selected-product.html',
      controller: SelectedProductController,
      controllerAs: 'selectedProduct'
    };
    return directive;
  }


  SelectedProductController.$inject = ['Common'];
  function SelectedProductController (Common) {
    const service = Common.get('serviceType'); //does not change on a page

    function getServiceType () {
      const addressType = Common.get('recipients.addressType');

      if (service === 'admail-letter' && addressType === 'ODR') {
        return 'admail-flyers';
      }
      return service;
    }

    const self = this;

    self.serviceType = getServiceType;
  }

})();
